module.exports = __webpack_public_path__ + "img/coupon.b9745eb9.gif";